import { FC, ReactElement } from 'react';

import { MeilisearchAttribute } from '../../../entities/@api/Meilisearch';
import { ProductOverviewInterface } from '../../../entities/@blocks/ProductOverview/ProductOverview';
import { MeilisearchStoreKey } from '../../../entities/@search/Meilisearch/Meilisearch';
import { generateMeilisearchFilterQuery } from '../../../entities/@search/Meilisearch/MeilisearchRequests';
import { inStockSort } from '../../../entities/Sort/Sort';
import { ConnectedProductList } from '../../ConnectedProductList/ConnectedProductList';

interface ConnectedProductOverviewProps extends ProductOverviewInterface {
    className?: string;
}

export const ConnectedProductOverview: FC<ConnectedProductOverviewProps> = ({
    id,
    title,
    productSelection,
    className = '',
}): ReactElement => {
    const storeKey = MeilisearchStoreKey.productOverviewBlock + id as MeilisearchStoreKey;

    const baseFilter = productSelection
        ? generateMeilisearchFilterQuery(MeilisearchAttribute.lists, productSelection.name)
        : '';

    return (
        <ConnectedProductList
            showFilterBar
            storeKey={storeKey}
            title={title}
            baseFilter={baseFilter}
            baseSort={inStockSort}
            className={className}
        />
    );
};
